<div [class]="loaderClass" style="background-color: white;" [style]="loaderStyle">
   <div class="div-wrapper">
      <div class="loader"></div>
      <h3>Đang tải dữ liệu...</h3>
   </div>
</div>
